import type { ReactNode } from 'react';

export type ChipTone = 'neutral' | 'blue' | 'green' | 'amber' | 'red' | 'violet';

const TONE: Record<ChipTone, string> = {
  neutral: 'bg-slate-100 text-slate-700 dark:bg-white/5 dark:text-slate-300',
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-300',
  green: 'bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-300',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300',
  red: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300',
  violet: 'bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300',
};

interface ChipProps {
  tone?: ChipTone;
  /** Compact rounded-full pill (default). Set false for a square chip. */
  pill?: boolean;
  uppercase?: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * Inline pill used for difficulty badges, tier labels, status, meta info.
 * Compact 11–12px text + bold weight, 100px radius.
 */
export function Chip({ tone = 'neutral', pill = true, uppercase = false, className = '', children }: ChipProps) {
  const shape = pill ? 'rounded-full' : 'rounded-lg';
  const text = uppercase ? 'text-[10.5px] uppercase tracking-wider' : 'text-[11.5px]';
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 font-extrabold ${shape} ${text} ${TONE[tone]} ${className}`}>
      {children}
    </span>
  );
}
